// Shared by the server-built earnings CSVs and the client-built payment breakdown CSV so the
// same order never shows two different rates depending on which file the creator downloaded.
const getEffectiveCommissionRateDisplay = (earnings, orderAmount) => {
  const order = Number(orderAmount);
  if (!(order > 0)) return '-';
  return `${((Number(earnings) / order) * 100).toFixed(2)}%`;
};

// The note is typed by the brand and opened by the payee, so any note a spreadsheet could read as a formula is
// prefixed with an apostrophe. Stricter than sanitizeCSVCellValue: a note is never a number.
const getBonusNoteDisplay = bonusNote => {
  if (!bonusNote) return '-';
  return /^[=+\-@\t\r\n]/.test(bonusNote) ? `'${bonusNote}` : bonusNote;
};

module.exports = { getEffectiveCommissionRateDisplay, getBonusNoteDisplay };
